import { Injectable } from '@angular/core';
import {UpdateCacheService} from "./update-cache.service";

@Injectable()
export class CacheMiddlewareService {
  selectedClientKey: string;
  locationKeys = [];

  constructor(
    private cache: UpdateCacheService
  ) { }


  updateDiscountsCache(clientCode, propertySoftware) {
    if (propertySoftware == 'sitelink' || propertySoftware === 'storage-commander') {
      return this.cache.updateDiscountsCache(clientCode, propertySoftware);
    }
    else if(propertySoftware == 'doorswap') {
      console.log(this.locationKeys);
      // return this.cache.doorswapUpdateDiscountCache(clientCode, this.locationKeys);
    }
  }

  updateInsuranceCache(clientCode, propertySoftware) {
    if (propertySoftware == 'sitelink' || propertySoftware === 'storage-commander') {
      return this.cache.updateInsuranceCache(clientCode, propertySoftware);
    }
  }

  updateAvailableUnitsCache(clientCode, propertySoftware) {
    if (propertySoftware == 'sitelink' || propertySoftware === 'storage-commander') {
      return this.cache.updateAvailableUnitsCache(clientCode, propertySoftware);
    }
  }

  updateAllUnitsCache(clientCode, propertySoftware) {
    if (propertySoftware == 'sitelink' || propertySoftware === 'storage-commander') {
      return this.cache.updateAllUnitsCache(clientCode, propertySoftware);
    }
  }

  updateEachAndEveryCache(clientCode, propertySoftware) {
    if (propertySoftware == 'sitelink' || propertySoftware === 'storage-commander' || propertySoftware == 'uhaul') {
      return this.cache.updateEachAndEveryCache(clientCode, propertySoftware);
    }
  }

}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/cache-middleware.service.ts